export const CHART8_REQUEST = "CHART8_REQUEST";
export const CHART8_SUCCESS = "CHART8_SUCCESS";
export const CHART8_FAILURE = "CHART8_FAILURE";
